import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import RubriqueCard from "layouts/gestion_sante_animale/component/RubriqueCard";
import globalStyles from "style";
import { Grid, IconButton } from "@mui/material";
import SearchBar from "layouts/gestion_sante_animale/component/SearchBar";

import MDTypography from "components/MDTypography";
import ServicesAPI from "./../../services/servicesAPI";
import { type RubriqueSanteAnimalType, defaultSelectedItemMpsa } from "constant/Types";
import RubriqueDialogAction from "layouts/gestion_sante_animale/component/RubriqueDialogAction";
import PDFViewerDialog from "layouts/gestion_sante_animale/component/PDFViewerDialog";
import LoadComponent from "components/LoadComponent/index";
// import COLORS from "../../../assets/theme/base/colors.js"
// import colors from "assets/theme/base/colors";
import { LAST_PATH } from "constant";
import {
  PATH_MEDICAMENT,
  MODULE_MEDICAMENT,
  PATH_MALADIE_ZOONOTIQUE,
  MODULE_MALADIE_ZOONOTIQUE,
  PATH_MALADIE_NON_ZOONOTIQUE,
  MODULE_MALADIE_NON_ZOONOTIQUE,
  MODULE_VACCIN,
  PATH_VACCIN,
  PATH_DIAGNOSTIC,
  MODULE_DIAGNOSTIC,
  // ENDPOINT_GET_DIAGNOSTIC_MALADIE,
  PATH_ANNEXE,
  MODULE_ANNEXE,
  PATH_TECHNIQUE,
  MODULE_TECHNIQUE,
  PATH_MPSA,
  MODULE_MALADIE_NON_OBLIGATOIRE,
  PATH_MALADIE_NON_OBLIGATOIRE,
  PATH_EXAMEN,
  MODULE_EXAMEN,
  MODULE_PRELEVEMENT,
  PATH_PRELEVEMENT,
  MODULE_TECHNIQUE_VETERINAIRE,
  PATH_TECHNIQUE_VETERINAIRE,
  PATH_AUTEUR,
  // MODULE_AUTEUR,
  // TITLE_AUTEUR,
} from "constant/moduleInfo";
import MDBox from "components/MDBox";

import SyncIcon from "@mui/icons-material/Sync";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { isAdmin } from "utils/userInfos";
import COLORS from "constant/colors";
import { useTranslation } from "react-i18next";
import MDButton from "components/MDButton/index";
import { ERROR } from "constant/message";

export default function IndexRubrique(): any {
  const location = useLocation();
  let pathName = location.pathname;
  const { t } = useTranslation("translation");
  const { i18n } = useTranslation();
  const servicesAPI = ServicesAPI();
  const navigate = useNavigate();
  const { isAlert, isLoading, message, alertSeverity, handleLoad, getAll, getAllMaladie } =
    servicesAPI;

  const [listData, setListData] = useState<RubriqueSanteAnimalType[]>([]);
  const [listFilterData, setlistFilterData] = useState<RubriqueSanteAnimalType[]>([]);
  const [listMaladieDiagnostic, setListMaladieDiagnostic] = useState<any>([]);
  const [listMaladie, setListMaladie] = useState<any>([]);
  const [selectedItem, setSelectedItem] =
    useState<RubriqueSanteAnimalType>(defaultSelectedItemMpsa);

  const [title, setTitle] = useState("");
  const [type, setType] = useState("");
  const [action, setAction] = useState("");
  // const [showName, setShowName] = useState("");
  const [openDialogAction, setOpenDialogAction] = useState(false);
  const [openPDFDialog, setOpenPDFDialog] = useState(false);
  const [pdfURL, setPdfURL] = useState("");
  const [pdfDiagnosticMaladieURL, setPdfDiagnosticMaladieURL] = useState("");

  const isAdminRole: boolean = isAdmin();
  // const isSuperAdminRole: boolean = isSuperAdmin();
  // Récupère la liste des données et les range dans un tableau
  const getAllData = (endpoint: string, typeRubrique: string): void => {
    // console.log("si18n.resolvedLanguage", i18n.resolvedLanguage);
    try {
      // console.log("sss", endpoint);
      getAll(endpoint).then((res: any) => {
        if (Array.isArray(res)) {
          // Ordonne le table par ordre alphabétique
          const result = res.map((i) => {
            let title = i.name;
            if (i18n.resolvedLanguage === "en") {
              title = i.nameEn;
            }
            return {
              ...i,
              ...{ title },
            };
          });
          setListData(result);
          setlistFilterData(result);

          // console.log("ddd", res);
          if (res.length === 0) {
            const loadData = {
              isAlert: true,
              message: `Aucune résultat trouvée`,
              isLoading: false,
              alertSeverity: "error",
            };
            handleLoad(loadData);
            setListData([]);
            setlistFilterData([]);
          } else if (!isAdminRole && location.pathname === PATH_AUTEUR) {
            // console.log("type", type, typeRubrique);
            handleOpenFile(result[0]?.title as string, false, null, typeRubrique);
          }
        }
      });
    } catch (error) {
      console.log("get_all_data error", error, listData.length);
    }
  };
  const getData = (endpoint: string): any => {
    try {
      return getAllMaladie(endpoint).then((res: any) => {
        let result: any = [];
        if (Array.isArray(res)) {
          result = res.map((i) => {
            let title = i.name;
            if (i18n.resolvedLanguage === "en") {
              title = i.nameEn;
            }
            return {
              ...i,
              ...{ title, label: title },
            };
          });
        }
        return result;
      });
    } catch (error) {
      console.log("get_all_data error", error, listData.length);
      return "error";
    }
  };
  const getAllMaladieByDiagnostic = async (diagnosticId: number): Promise<void> => {
    try {
      // servicesAPI.getAll(`${ENDPOINT_GET_DIAGNOSTIC_MALADIE}${diagnostic}`).then((res: any) => {
      await servicesAPI.getAll(`maletes/diagnostic/${diagnosticId}/maladies`).then((res: any) => {
        // console.log("dddd", res);
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        if (Object.keys(res).length > 0 && Array.isArray(res)) {
          // if (Object.keys(res).length > 0 && Array.isArray(res.maladies)) {
          const result = res
            .map((i) => {
              let title = i.name;
              if (i18n.resolvedLanguage === "en") {
                title = i.nameEn;
              }
              const item = {
                ...i,
                ...{ title, label: title },
              };
              return item;
            })
            .sort((a, b) => {
              const nameA = a.label.toUpperCase(); // ignore upper and lowercase
              const nameB = b.label.toUpperCase(); // ignore upper and lowercase

              if (nameA < nameB) {
                return -1;
              }
              if (nameA > nameB) {
                return 1;
              }

              // names must be equal
              return 0;
            });

          // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
          setListMaladieDiagnostic(result);
          // console.log("sss//", result);
        }
      });
    } catch (error) {
      console.log("get_all_data error", error, listData.length);
    }
  };
  /* const getRubriqueInfos = (): void => {
    let titleRubrique: string = "";
    let endPointRubrique: string = "";
    let module: string = "";
    let typeRubrique: string = "";
    if (location.pathname === PATH_MEDICAMENT) {
      titleRubrique = t("medicaments");
      endPointRubrique = ENDPOINT_GET_MEDICAMENT;
      module = MODULE_MEDICAMENT;
      typeRubrique = MODULE_MEDICAMENT;
    } else if (location.pathname === PATH_VACCIN) {
      titleRubrique = t("vaccins");
      endPointRubrique = ENDPOINT_GET_VACCIN;
      module = MODULE_VACCIN;
      typeRubrique = MODULE_VACCIN;
    } else if (location.pathname === PATH_ANNEXE) {
      titleRubrique = t("annexe");
      endPointRubrique = ENDPOINT_GET_ANNEXE;
      module = MODULE_ANNEXE;
      typeRubrique = MODULE_ANNEXE;
    } else if (location.pathname === PATH_MALADIE_ZOONOTIQUE) {
      titleRubrique = t("maladie_zoonotique");
      endPointRubrique = ENDPOINT_GET_MALADIE_ZOONOTIQUE;
      module = MODULE_MALADIE_ZOONOTIQUE;
      typeRubrique = MODULE_MALADIE;
    } else if (location.pathname === PATH_MALADIE_NON_OBLIGATOIRE) {
      titleRubrique = t("maladie_non_zoonotique");
      endPointRubrique = ENDPOINT_GET_MALADIE_ZOONOTIQUE;
      module = MODULE_MALADIE_ZOONOTIQUE;
      typeRubrique = MODULE_MALADIE;
    } else if (location.pathname === PATH_MALADIE_NON_ZOONOTIQUE) {
      titleRubrique = t("maladie_non_obligatoire");
      endPointRubrique = ENDPOINT_GET_MALADIE_NON_ZOONOTIQUE;
      module = MODULE_MALADIE_NON_ZOONOTIQUE;
      typeRubrique = MODULE_MALADIE;
    } else if (location.pathname === PATH_DIAGNOSTIC) {
      titleRubrique = t("diagnostics");
      endPointRubrique = ENDPOINT_GET_DIAGNOSTIC;
      module = MODULE_DIAGNOSTIC;
      typeRubrique = MODULE_DIAGNOSTIC;
    } else if (location.pathname === PATH_TECHNIQUE) {
      titleRubrique = t("technique");
      endPointRubrique = ENDPOINT_GET_TECHNIQUE;
      module = MODULE_TECHNIQUE;
      typeRubrique = MODULE_TECHNIQUE;
    } else if (location.pathname === PATH_EXAMEN) {
      titleRubrique = t("examen");
      endPointRubrique = ENDPOINT_GET_MEDICAMENT;
      module = "Examen Clinique";
      typeRubrique = MODULE_MEDICAMENT;
    } else if (location.pathname === PATH_PRELEVEMENT) {
      titleRubrique = t("prelevements");
      endPointRubrique = ENDPOINT_GET_MEDICAMENT;
      module = MODULE_PRELEVEMENT;
      typeRubrique = MODULE_MEDICAMENT;
    } else if (location.pathname === PATH_TECHNIQUE_VETERINAIRE) {
      titleRubrique = t("technique_veterinaire");
      endPointRubrique = ENDPOINT_GET_MEDICAMENT;
      module = MODULE_TECHNIQUE_VETERINAIRE;
      typeRubrique = MODULE_MEDICAMENT;
    } else if (location.pathname === PATH_AUTEUR) {
      titleRubrique = t("auteurs");
      endPointRubrique = ENDPOINT_GET_MEDICAMENT;
      module = MODULE_AUTEUR;
      typeRubrique = MODULE_MEDICAMENT;
      handleOpenFile(TITLE_AUTEUR, false);
    }
    if (endPointRubrique !== "") {
      setTitle(titleRubrique);
      getAllData(endPointRubrique);
      setShowName(module);
      setType(typeRubrique);
    } else {
      setTitle("");
      setShowName("");
      setType("");
      const loadData = {
        isAlert: true,
        message: "Module Indisponible",
        isLoading: false,
        alertSeverity: "error",
      };
      handleLoad(loadData);
    }
    // }
  }; */

  const getRubriqueInfos = (): void => {
    let titleRubrique = "";
    let endPointRubrique = "maletes";
    // let module = "";
    let typeRubrique = "";
    if (location.pathname === PATH_MEDICAMENT) {
      titleRubrique = t("medicaments");
      endPointRubrique = `${endPointRubrique}/${MODULE_MEDICAMENT}`;
      // module = MODULE_MEDICAMENT;
      typeRubrique = MODULE_MEDICAMENT;
    } else if (location.pathname === PATH_VACCIN) {
      titleRubrique = t("vaccins");
      endPointRubrique = `${endPointRubrique}/${MODULE_VACCIN}`;
      // module = MODULE_VACCIN;
      typeRubrique = MODULE_VACCIN;
    } else if (location.pathname === PATH_ANNEXE) {
      titleRubrique = t("annex");
      endPointRubrique = `${endPointRubrique}/${MODULE_ANNEXE}`;
      // module = MODULE_ANNEXE;
      typeRubrique = MODULE_ANNEXE;
    } else if (location.pathname === PATH_MALADIE_ZOONOTIQUE) {
      titleRubrique = t("maladie_zoonotique");
      endPointRubrique = `${endPointRubrique}/${MODULE_MALADIE_ZOONOTIQUE}`;
      // module = MODULE_MALADIE_ZOONOTIQUE;
      typeRubrique = MODULE_MALADIE_ZOONOTIQUE;
    } else if (location.pathname === PATH_MALADIE_NON_OBLIGATOIRE) {
      titleRubrique = t("maladie_non_obligatoire");
      endPointRubrique = `${endPointRubrique}/${MODULE_MALADIE_NON_OBLIGATOIRE}`;
      // module = MODULE_MALADIE_NON_OBLIGATOIRE;
      typeRubrique = MODULE_MALADIE_NON_OBLIGATOIRE;
    } else if (location.pathname === PATH_MALADIE_NON_ZOONOTIQUE) {
      titleRubrique = t("maladie_non_zoonotique");
      endPointRubrique = `${endPointRubrique}/${MODULE_MALADIE_NON_ZOONOTIQUE}`;
      // module = MODULE_MALADIE_NON_ZOONOTIQUE;
      typeRubrique = MODULE_MALADIE_NON_ZOONOTIQUE;
    } else if (location.pathname === PATH_DIAGNOSTIC) {
      titleRubrique = t("diagnostics");
      endPointRubrique = `${endPointRubrique}/${MODULE_DIAGNOSTIC}`;
      // module = MODULE_DIAGNOSTIC;
      typeRubrique = MODULE_DIAGNOSTIC;
    } else if (location.pathname === PATH_TECHNIQUE) {
      titleRubrique = t("technique");
      endPointRubrique = `${endPointRubrique}/${MODULE_TECHNIQUE}`;
      // module = MODULE_TECHNIQUE;
      typeRubrique = MODULE_TECHNIQUE;
    } else if (location.pathname === PATH_EXAMEN) {
      titleRubrique = t("examen");
      endPointRubrique = `${endPointRubrique}/${MODULE_EXAMEN}`;
      // module = MODULE_EXAMEN;
      typeRubrique = MODULE_EXAMEN;
    } else if (location.pathname === PATH_PRELEVEMENT) {
      titleRubrique = t("prelevements");
      endPointRubrique = `${endPointRubrique}/${MODULE_PRELEVEMENT}`;
      // module = MODULE_PRELEVEMENT;
      typeRubrique = MODULE_PRELEVEMENT;
    } else if (location.pathname === PATH_TECHNIQUE_VETERINAIRE) {
      titleRubrique = t("technique_veterinaire");
      // endPointRubrique = ENDPOINT_GET_MEDICAMENT;
      endPointRubrique = `${endPointRubrique}/${MODULE_TECHNIQUE_VETERINAIRE}`;
      typeRubrique = MODULE_TECHNIQUE_VETERINAIRE;
    } else if (location.pathname === PATH_AUTEUR) {
      titleRubrique = t("auteurs");
      /* if (TITLE_AUTEUR === "zzz") {
        endPointRubrique = `${endPointRubrique}/${MODULE_AUTEUR}`;
        module = MODULE_AUTEUR;
        typeRubrique = MODULE_AUTEUR;
      } */
      endPointRubrique = `${endPointRubrique}/${MODULE_ANNEXE}`;
      // module = MODULE_ANNEXE;
      typeRubrique = MODULE_ANNEXE;
    }
    if (endPointRubrique !== "") {
      setTitle(titleRubrique);
      setType(typeRubrique);
      getAllData(endPointRubrique, typeRubrique);
    } else {
      setTitle("");
      setType("");
      const loadData = {
        isAlert: true,
        message: "Module Indisponible",
        isLoading: false,
        alertSeverity: "error",
      };
      handleLoad(loadData);
    }
    // console.log("aa", module);
    // }
  };
  const initialization = (): void => {
    setListData([]);
    setlistFilterData([]);
    setListMaladieDiagnostic([]);
    setAction("");
    setSelectedItem(defaultSelectedItemMpsa);
    getRubriqueInfos();
  };
  useEffect(() => {
    pathName = location.pathname;
    localStorage.setItem(String(LAST_PATH), location.pathname);
    initialization();
  }, [location.pathname, i18n.resolvedLanguage]);
  // ouvre un modal (boite de dialogue) contenant les boutons upload et download
  const handleOpenDialogAction = async (
    value: RubriqueSanteAnimalType,
    action: string
  ): Promise<void> => {
    setSelectedItem(value);
    setAction(action);
    if (pathName === PATH_DIAGNOSTIC) {
      const maladieZoonotique = await getData(`maletes/${MODULE_MALADIE_ZOONOTIQUE}`);
      const maladieNonObligatoire = await getData(`maletes/${MODULE_MALADIE_NON_OBLIGATOIRE}`);
      const maladieNonZoonotique = await getData(`maletes/${MODULE_MALADIE_NON_ZOONOTIQUE}`);
      let AllMaladies: any = [];
      if (Array.isArray(maladieZoonotique)) {
        AllMaladies = [...AllMaladies, ...maladieZoonotique];
      }
      if (Array.isArray(maladieNonObligatoire)) {
        AllMaladies = [...AllMaladies, ...maladieNonObligatoire];
      }
      if (Array.isArray(maladieNonZoonotique)) {
        AllMaladies = [...AllMaladies, ...maladieNonZoonotique];
      }
      setListMaladie(AllMaladies);
      if (action === "edit") {
        await getAllMaladieByDiagnostic(value.id);
      }
    }
    if (isAdminRole || value.name === "Antiparasitaires") {
      setOpenDialogAction(true);
    } else {
      handleOpenFile(value.title, false, null, type);
    }
  };
  const handleCloseDialogAction = (): void => {
    setSelectedItem(defaultSelectedItemMpsa);
    setOpenDialogAction(false);
    setListMaladieDiagnostic([]);
    setPdfDiagnosticMaladieURL("");
  };
  // Récupère le fichier associer à l'élément sélectionné
  const handleOpenFile = (
    fileName: string,
    isDiagnosticbyMaladie: boolean,
    maladie: any,
    typeRubrique: string
  ): void => {
    try {
      // setPdfURL("");
      let typeFile = typeRubrique;
      if (isDiagnosticbyMaladie) {
        typeFile = maladie?.type;
      }
      servicesAPI.downloadFile(fileName, typeFile).then(async (res: any) => {
        if (res !== "error") {
          // Convert the PDF string to a Blob object
          // console.log("dddd res", res);

          const pdfBlob = new Blob([res], { type: "application/pdf" });
          // const pdfBlob = new Blob([res], { type: "text/html" });
          // Create a URL for the Blob object
          const pdfBlobURL = URL.createObjectURL(pdfBlob);
          // open url in new tab
          // setIsPdfViewer(true);
          // setPdfUrl(pdfBlobURL);
          if (isDiagnosticbyMaladie) {
            setPdfDiagnosticMaladieURL(pdfBlobURL);
          } else {
            setOpenDialogAction(false);
            setPdfURL(pdfBlobURL);
            setOpenPDFDialog(true);
            // }
          }
        }
      });
    } catch (error) {
      console.log("handleGetFile error", error);
    }
  };
  // Upload un fichier pour l'associer à l'élément sélectionné
  // const handleUplaodFile = (file: Blob, fileName: string): void => {
  const handleUplaodFile = (fileData: any): void => {
    try {
      if (fileData.file !== null) {
        /*  let endpoint= ""
        if(location.pathname=== PATH_ANNEXE) {
          endpoint=ENDPOINT_UPLOAD_ANNEXE
        } else {
          endpoint=
        } */
        console.log("zzz", fileData);
        // servicesAPI.uploadFile(file, fileName).then(async (res: any) => {
        servicesAPI.uploadFile(fileData.file, fileData.name, type).then(async (res: any) => {
          // uploadFile(file, name).then(async (res) => {
          if (res !== "axios_error" && res !== ERROR) {
            // refresh();
            setTimeout(() => {
              console.log("upload over");
              // handleCloseDialogAction();
              handleOpenFile(fileData.name as string, false, null, type);
            }, 200);
          }

          // console.log("here i am////", res, file.name, selectedItem.nom);
        });
      } else {
        alert("Veuillez choisir un fichier");
      }
    } catch (error) {
      console.log("handlePostFile error", error);
    }
  };
  const handleClosePDFDialog = (): void => {
    setOpenPDFDialog(false);
    setPdfURL("");
    setSelectedItem(defaultSelectedItemMpsa);
    setListMaladieDiagnostic([]);
    setPdfDiagnosticMaladieURL("");
  };
  const goBack = (): void => {
    //  console.log("dddd");
    navigate(PATH_MPSA, { state: { prevPath: location.pathname } });
  };
  const refresh = (): void => {
    handleCloseDialogAction();
    initialization();
  };
  const gobalClasses = globalStyles();

  const saveFile = async (fileData: any): Promise<any> => {
    // console.log("rrr", type);
    const result = await servicesAPI.uploadFile(fileData.file, fileData.name, type);
    return result;
  };
  const editNames = async (item: any): Promise<any> => {
    let endpointFr = "";
    let endpointEn = "";

    let resultFr = "";
    let resultEn = "";
    let result = "";
    if (item.name !== selectedItem.name) {
      endpointFr = `maletes?id=${item.id}&nom=${item.name}&lang=FR&businessType=${type}`;
    }
    if (item.nameEn !== selectedItem.nameEn) {
      endpointEn = `maletes?id=${item.id}&nom=${item.nameEn}&lang=EN&businessType=${type}`;
    }
    if (endpointFr !== "" || endpointEn !== "") {
      console.log(-"update can start");
      if (endpointFr !== "") {
        resultFr = await servicesAPI.putData(endpointFr, []);
      }
      if (endpointEn !== "") {
        resultEn = await servicesAPI.putData(endpointEn, []);
      }
      /* console.log("resultFr", resultFr);
      console.log("resultEn", resultEn);
      if (resultFr !== "ERROR" && resultEn !== "Error") {
        setTimeout(() => {
          // console.log("Save + upload over");
          refresh();
        }, 200);
      } */
      if (resultFr === "Error" || resultEn === "Error") {
        result = "Error";
      }
    } else {
      const loadData = {
        isAlert: true,
        message: t("noUpdateFound"),
        isLoading: false,
        alertSeverity: "error",
      };
      result = "Error";
      handleLoad(loadData);
    }
    return result;
    // return result;
  };
  const deleteData = async (item: any): Promise<any> => {
    const endpoint = `maletes?id=${item.id}&businessType=${type}`;
    const result = await servicesAPI.deleteData(endpoint);
    // return result;
    console.log("zzz", result);
    if (result !== ERROR) {
      setTimeout(() => {
        refresh();
      }, 200);
    }
  };
  const handleSaveMaladieDiagnostics = async (
    maladieDiagnostic: any,
    diagnosticId: number
  ): Promise<string> => {
    try {
      const results = await Promise.all(
        maladieDiagnostic.map(async (i: any) => {
          try {
            const linkMaladie = await servicesAPI.postData(
              `maletes/maladie/diagnostics?maladieId=${i?.id}&diagnosticId=${diagnosticId}`
            );
            if (linkMaladie !== ERROR) {
              console.log("Enregistré avec succès :", linkMaladie);
              return { success: true, data: i }; // Renvoie l'élément en cas de succès
            } else {
              console.error("Erreur lors de l'enregistrement :", i);
              return { success: false, data: i, ERROR }; // Capture l'élément et l'erreur en cas d'échec
            }
          } catch (error) {
            console.error("Erreur lors de l'enregistrement :", error, i);
            return { success: false, data: i, error }; // Capture l'élément et l'erreur en cas d'échec
          }
        })
      );

      // Vérifiez les résultats pour déterminer si tout est réussi
      const failures = results.filter((result) => result.success === false);

      if (failures.length > 0) {
        console.log("Échec pour certains éléments :", failures);
        alert(
          `Enregistrement partiel réussi. Échecs : ${failures
            .map((failure) => JSON.stringify(failure.data))
            .join(", ")}`
        );
        return ERROR;
      } else {
        // console.log("Tous les éléments ont été enregistrés avec succès !");
        // alert("Enregistrement complet réussi !");
        return "success";
      }
    } catch (error) {
      console.error("Erreur inattendue :", error);
      alert("Une erreur inattendue s'est produite.");
      return ERROR;
    }
  };
  const handleRemoveMaladieDiagnostics = async (
    maladieDiagnostic: any,
    diagnosticId: number
  ): Promise<string> => {
    try {
      const results = await Promise.all(
        maladieDiagnostic.map(async (i: any) => {
          try {
            const unLinkMaladie = await servicesAPI.postData(
              `maletes/maladie/diagnostics/unlink?maladieId=${i?.id}&diagnosticId=${diagnosticId}`
            );
            if (unLinkMaladie !== ERROR) {
              console.log("Enregistré avec succès :", unLinkMaladie);
              return { success: true, data: i }; // Renvoie l'élément en cas de succès
            } else {
              console.error("Erreur lors de l'enregistrement :", i);
              return { success: false, data: i, ERROR }; // Capture l'élément et l'erreur en cas d'échec
            }
          } catch (error) {
            console.error("Erreur lors de l'enregistrement :", error, i);
            return { success: false, data: i, error }; // Capture l'élément et l'erreur en cas d'échec
          }
        })
      );

      // Vérifiez les résultats pour déterminer si tout est réussi
      const failures = results.filter((result) => result.success === false);

      if (failures.length > 0) {
        console.log("Échec pour certains éléments :", failures);
        alert(
          `Enregistrement partiel réussi. Échecs : ${failures
            .map((failure) => JSON.stringify(failure.data))
            .join(", ")}`
        );
        return ERROR;
      } else {
        // console.log("Tous les éléments ont été enregistrés avec succès !");
        // alert("Enregistrement complet réussi !");
        return "success";
      }
    } catch (error) {
      console.error("Erreur inattendue :", error);
      alert("Une erreur inattendue s'est produite.");
      return ERROR;
    }
  };

  const saveNames = async (item: any): Promise<any> => {
    const endpoint = "maletes";
    const result = await servicesAPI.postData(endpoint, [item]);
    return result;
  };
  const saveData = async (data: any, item: any, maladieDiagnostic: any): Promise<void> => {
    const nameValues = {
      ...item,
      ...{ type },
    };
    const nameSaveResult = await saveNames(nameValues);
    if (nameSaveResult !== "error") {
      await saveFile(data[0]);
      await saveFile(data[1]);
      if (pathName === PATH_DIAGNOSTIC && maladieDiagnostic.length > 0) {
        console.log("nameSaveResult", nameSaveResult);
        const linkMaladie = await handleSaveMaladieDiagnostics(
          maladieDiagnostic,
          nameSaveResult[0]?.id as number
        );
        if (linkMaladie !== ERROR) {
          setTimeout(() => {
            refresh();
          }, 200);
        }
      } else {
        setTimeout(() => {
          // console.log("Save + upload over");
          refresh();
        }, 200);
      }
    }
  };
  const editData = async (
    item: any,
    newMaladieDiagnostic: any,
    removedMaladieDiagnostic: any
  ): Promise<void> => {
    const nameEditResult = await editNames(item);
    if (nameEditResult !== "error") {
      if (pathName === PATH_DIAGNOSTIC) {
        /* console.log("nameEditeResult", item);
        console.log("newMaladieDiagnostic", newMaladieDiagnostic);
        console.log("removedMaladieDiagnostic", removedMaladieDiagnostic); */
        let linkMaladie = "";
        let unLinkMaladie = "";
        if (newMaladieDiagnostic.length > 0) {
          linkMaladie = await handleSaveMaladieDiagnostics(
            newMaladieDiagnostic,
            item?.id as number
          );
        }
        if (removedMaladieDiagnostic.length > 0) {
          unLinkMaladie = await handleRemoveMaladieDiagnostics(
            removedMaladieDiagnostic,
            item?.id as number
          );
        }
        if (linkMaladie !== ERROR && unLinkMaladie !== ERROR) {
          setTimeout(() => {
            refresh();
          }, 200);
        }
      } else {
        setTimeout(() => {
          // console.log("Save + upload over");
          refresh();
        }, 200);
      }
    }
  };
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div>
        <MDTypography
          display="block"
          variant="H1"
          fontWeight="medium"
          align="center"
          style={{ color: COLORS.primary, marginBottom: 10 }}
        >
          {title}
        </MDTypography>
        <MDBox
          display="flex"
          alignItems="center"
          sx={{ justifyContent: "center", alignItems: "center" }}
        >
          <IconButton onClick={goBack}>
            <ArrowBackIcon fontSize="small" style={{ color: "gray" }} />
          </IconButton>
          <IconButton onClick={refresh}>
            <SyncIcon fontSize="small" style={{ color: "gray" }} />
          </IconButton>
        </MDBox>
        <SearchBar dataArray={listData} setFilterArray={setlistFilterData} isLoading={isLoading} />
        {isAdminRole && (
          <MDButton
            type="submit"
            variant="gradient"
            color="info"
            sx={{ marginLeft: "auto", marginRight: 10 }}
            // style={{}}
            onClick={async () => {
              await handleOpenDialogAction(defaultSelectedItemMpsa, "add");
            }}
          >
            {t("add")}
          </MDButton>
        )}
        <div
          className={gobalClasses.centerContent}
          style={{ marginTop: 15, marginBottom: 15, width: "100%" }}
        >
          <Grid container spacing={3} sx={{ justifyContent: "center", alignItems: "center" }}>
            {listFilterData.map((i) => (
              <Grid item xs={12} lg={4} key={i.id}>
                {i.title !== null && (
                  <RubriqueCard cardData={i} handleOpenDialogAction={handleOpenDialogAction} />
                )}
              </Grid>
            ))}
          </Grid>
        </div>
        {openDialogAction && (
          <RubriqueDialogAction
            selectedItem={selectedItem}
            handleOpenFile={handleOpenFile}
            handleUploadFile={handleUplaodFile}
            handleClose={handleCloseDialogAction}
            open={openDialogAction}
            action={action}
            saveData={saveData}
            editData={editData}
            deleteData={deleteData}
            listMaladie={listMaladie}
            listMaladieDiagnostic={listMaladieDiagnostic}
            pathName={location.pathname}
            type={type}
          />
        )}
        {openPDFDialog && (
          <PDFViewerDialog
            selectedItem={selectedItem}
            pdfURL={pdfURL}
            handleClose={handleClosePDFDialog}
            open={openPDFDialog}
            listMaladieDiagnostic={listMaladieDiagnostic}
            handleOpenMaladieFile={handleOpenFile}
            pdfDiagnosticMaladieURL={pdfDiagnosticMaladieURL}
            setPdfDiagnosticMaladieURL={setPdfDiagnosticMaladieURL}
          />
        )}
        <LoadComponent
          isAlert={isAlert}
          isLoading={isLoading}
          message={message}
          alertSeverity={alertSeverity}
          handleLoad={handleLoad}
        />
      </div>
    </DashboardLayout>
  );
}
